import type { ProductAnnouncement } from "@/generated/email_parser.openapi";

export function filterVisibleAnnouncements(
  items: ProductAnnouncement[],
  isFeatureEnabled: (featureFlag: string) => boolean | undefined
): ProductAnnouncement[] {
  return items.filter(
    (item) => !item.featureFlag || isFeatureEnabled(item.featureFlag) === true
  );
}

// The provider is mounted in `app/(app)/layout.tsx`, which covers onboarding as well.
// Onboarding is a linear flow that even hides the header (see RightContainer), so no
// announcement should pop over it.
export function isAnnouncementTeaserSuppressed(
  pathname: string | null
): boolean {
  return pathname?.startsWith("/onboarding") ?? false;
}
